export const getEmailForCountryCode = (countryCode = 'DE') => {
    switch (countryCode.toUpperCase()) {
    case 'DE':
        return 'info@plusdental.de'
    case 'AT':
        return 'info@plusdental.at'
    case 'CH':
        return 'info@plusdental.ch'
    case 'GB':
        return 'info@plusdent.co.uk'
    default:
        return 'info@plusdental.de'
    }
}

export const getTreatmentCheckoutForCountryCode = (countryCode = 'DE') => {
    switch (countryCode.toUpperCase()) {
    case 'DE':
        return 'https://www.plusdental.de/account/checkout-treatment'
    case 'AT':
        return 'https://www.plusdental.at/account/checkout-treatment'
    case 'CH':
        return 'https://www.plusdental.ch/account/checkout-treatment'
    case 'GB':
        return 'https://www.plusdent.co.uk/account/checkout-treatment'
    default:
        return 'https://www.plusdental.de/account/checkout-treatment'
    }
}



// WEBPACK FOOTER //
// ./src/util/localized-urls.js